module.exports = __webpack_public_path__ + "img/BA_Logo_Horizontal_White.ce21c808.svg";